import { useEffect, useState } from "react";

const PortfolioOne = () => {
  const [portfolioItems, setPortfolioItems] = useState([]);

  useEffect(() => {
    // Use static portfolio data instead of fetching from an API
    const data = [
      {
        id: 1,
        title: "Coworking Website",
        image: "/img/case-1.jpg",
        categories: ["Web Development", "UI/UX"],
        link: "/beyondjustwork"
      },
      {
        id: 2,
        title: "Hospitality Website",
        image: "/img/case-2.jpg",
        categories: ["Wordpress", "Design"],
        link: "/casapalmira"
      },
      {
  id: 3,
  title: "Itaiba Retreat",
  image: "/img/case-itaiba.png",
  categories: ["Development", "Hospitality"],
  link: "/itaiba-retreat"
},
      {
        id: 4,
        title: "Resort Website",
        image: "/img/case-4.jpg",
        categories: ["Web Application", "High Customization"],
        link: "/fanaresort"
      },
    ];

    setPortfolioItems(data);
  }, []);

  return (
    <div className="row">
      <div className="stack-wrapper">
        {portfolioItems.map((item) => (
          <div className="stack-item" key={item.id}>
            <div className="card portfolio-item layout-2 scale has-shadow">
              <div className="image-holder">
                <a className="card-thumb" href={item.link}>
                  <img src={item.image} alt={item.title} />
                </a>
                <div className="card-overlay">
                  <div className="heading">
                    <h4 className="title mt-2 mt-md-3 mb-3">{item.title}</h4>
                    <div className="show-project">
                      <div className="card-terms">
                        {item.categories.map((category, index) => (
                          <a
                            className="terms badge outlined"
                            href="/portfolio"
                            key={index}
                          >
                            {category}
                          </a>
                        ))}
                      </div>
                      <div className="project-link">
                        <a href={item.link}>Show Project</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PortfolioOne;


